module.exports = __webpack_public_path__ + "img/ico_sub_design.9661cc65.svg";